import { ThemeEvents } from "@theme/events";

class TinMeter extends HTMLElement {
  #requestToken = 0;
  connectedCallback() {
    this.eligibleVariantIds = new Set(this.#parseVariantIds());
    this.goal = Number(this.dataset.goal || 12);
    this.fill = this.querySelector("[data-tin-meter-fill]");
    this.message = this.querySelector("[data-tin-meter-message]");
    this.reward = this.querySelector("[data-tin-meter-reward]");
    this.progress = this.querySelector('[role="progressbar"]');

    document.addEventListener(ThemeEvents.cartUpdate, this.#onCartUpdate);
    this.#fetchAndUpdate();
  }

  disconnectedCallback() {
    document.removeEventListener(ThemeEvents.cartUpdate, this.#onCartUpdate);
  }

  #parseVariantIds() {
    try {
      return JSON.parse(this.dataset.eligibleVariantIds || "[]").map(String);
    } catch {
      return [];
    }
  }

  #onCartUpdate = (event) => {
    this.#requestToken++;
    const cart = event.detail?.resource;
    // Add responses contain only the added lines; only full carts have item_count.
    if (Array.isArray(cart?.items) && Number.isFinite(cart.item_count)) {
      this.#update(cart);
      return;
    }
    this.#fetchAndUpdate();
  };

  async #fetchAndUpdate() {
    const token = ++this.#requestToken;
    try {
      const response = await fetch("/cart.js", { cache: "no-store" });
      if (!response.ok) return;
      const cart = await response.json();
      if (token !== this.#requestToken) return;
      this.#update(cart);
    } catch {
      // Keep the server-rendered zero state if the cart cannot be retrieved.
    }
  }

  #update(cart) {
    const count = (cart.items || []).reduce((total, item) => {
      const isBundleChild = Boolean(item.properties?._parent_bundle_id);
      return !isBundleChild && this.eligibleVariantIds.has(String(item.variant_id))
        ? total + Number(item.quantity || 0)
        : total;
    }, 0);
    const complete = count >= this.goal;
    const percent = Math.min((count / this.goal) * 100, 100);

    if (this.fill) this.fill.style.width = `${percent}%`;
    if (this.progress) this.progress.setAttribute("aria-valuenow", String(Math.min(count, this.goal)));
    if (this.reward) this.reward.textContent = complete ? "FREE TIN UNLOCKED" : "GET 1 TIN FOR FREE";
    if (this.message) {
      this.message.textContent = complete
        ? "Your free tin is unlocked!"
        : count === 0
          ? "Build your spice shelf to unlock a free tin."
          : `${this.goal - count} more ${this.goal - count === 1 ? "tin" : "tins"} to go!`;
    }
  }
}

if (!customElements.get("tin-meter")) customElements.define("tin-meter", TinMeter);
